<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Evaluate.id==0">فرم ثبت سوال بازنگری</h5>
      <h5 class="card-title" *ngIf="inner_Evaluate.id>0">فرم ویرایش سوال بازنگری</h5>
      <form [formGroup]="FormEvaluate" >

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">عنوان</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6" [hidden]="inner_Evaluate.id>0">
            <label for="exampleInputEmail1">نوع</label>
            <select formControlName="Type" class="custom-select">
              <option value="0">انتخاب کنید</option>
              <option value="1">انتخاب یک مورد</option>
              <option value="2">تایپ</option>
            </select>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </form>

      <br/>
      <hr/>
      <br/>

      <div [hidden]="get_Form_Type().value!='1'">

        <h5> گزینه ها </h5>

        <br />

        <form>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> عنوان گزینه : </label>
              <input [(ngModel)]="Option_Input" name="Option_Input" type="text" class="form-control"
                placeholder="اینجا تایپ کنید ...">
            </div>
          </div>

          <button type="button" (click)="Option_Submit()" class="btn btn-danger" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> افزودن گزینه </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="Option.length>0">

          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>گزینه</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Option">
                <td>{{Option.indexOf(item)+1}}</td>
                <td>{{item}}</td>
                <td style="cursor: pointer;">
                  <a style="cursor: pointer;" (click)="Option_Delete(Option.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <br />
        <br />

        <br/>
        <hr/>
        <br/>
      </div>


      <button *ngIf="!InProccessing && inner_Evaluate.id==0" type="button" (click)="SubmitFormEvaluate()" [disabled]="!FormEvaluate.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button *ngIf="!InProccessing && inner_Evaluate.id>0" type="button" (click)="SubmitFormEvaluate()" [disabled]="!FormEvaluate.valid" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش اطلاعات </button>
  </div>
</div>
